<div class="header">
  <div class="title flex">
    <div>{{partition ? 'Partition' : 'Site'}} Arming Schedule</div>
  </div>
  <div></div>
  <div class="btn-area" *ngIf="canControlSchedulArming() && armingScheduleState === 'schedule-table'">
    <div class="space"></div>
    <div class="v-center" *ngIf="isEditMode" style="gap: 8px">
      <div class="button button-white" (click)="openAddArmSchedule()" [class.disabled]="!canEditShceuldArming()">
        <div class="btn-inner">Bulk Add Schedule</div>
      </div>
      <div class="button button-white" (click)="onClickCancel()" [class.disabled]="isLoading">
        <div class="btn-inner">Cancel</div>
      </div>
      <div class="button button-primary" (click)="onClickSave()" [class.disabled]="isLoading">
        <div class="btn-inner">Save </div>
      </div>
    </div>
    <ng-container *ngIf="!isEditMode">
      <div class="button button-white" (click)="changeEditMode()" [class.disabled]="isLoading || !canEditShceuldArming()">
        <div class="btn-inner">Edit</div>
      </div>
    </ng-container>
  </div>
</div>
<div class="widget-body" *ngIf="armingScheduleState === 'no-checkt-bridge'">
  <div class="item-row">
    <div class="flex-column align-center justify-center" style="justify-content: center;width: 100%;">
      <div class="mb-24">
        <comp-icon [icon]="'safety_check'" [size]="'40'" [color]="'#8792A2'"></comp-icon>
      </div>
      <div class="arming-description">To use Scheduled Arming, please register a CHeKT bridge on this site.</div>
    </div>
  </div>
</div>
<div class="widget-body" *ngIf="armingScheduleState === 'has-unregistered-bridge'">
  <div class="item-row">
    <div class="flex-column align-center justify-center" style="justify-content: center;width: 100%;">
      <div class="mb-24">
        <comp-icon [icon]="'safety_check'" [size]="'40'" [color]="'#8792A2'"></comp-icon>
      </div>
      <div class="arming-description">Scheduled Arming is unavailable because one or more bridges are unregistered.</div>
      <div class="arming-description">Please register all bridges on this site to enable this feature.</div>
    </div>
  </div>
</div>
<div class="widget-body" *ngIf="armingScheduleState === 'no-schedule'">
  <div class="item-row">
    <div class="flex-column align-center justify-center" style="justify-content: center;width: 100%;">
      <div class="mb-24">
        <comp-icon [icon]="'safety_check'" [size]="'40'" [color]="'#8792A2'"></comp-icon>
      </div>
      <div>
        <div class="btn-area">
          <div class="button button-white" (click)="openAddArmSchedule()" [class.disabled]="isLoading || !canControlSchedulArming()">
            <div class="btn-inner">Set up your first arming schedule</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="widget-body" *ngIf="armingScheduleState === 'not-support-firmware'">
  <div class="item-row">
    <div class="flex-column align-center justify-center" style="justify-content: center;width: 100%;">
      <div class="mb-14">
        <comp-icon [icon]="'safety_check'" [size]="'40'" [color]="'#8792A2'"></comp-icon>
      </div>
      <div class="mb-20" style="text-align: center;">
        <div class="arming-description">To support an arming schedule,</div>
        <div class="arming-description">your Bridge requires a firmware update.</div>
      </div>
      <div>
        <div class="btn-area">
          <div class="button button-white" (click)="goToDeviceList()" [class.disabled]="isLoading || !canControlSchedulArming()">
            <div class="btn-inner">Go to update FW</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="widget-body" *ngIf="armingScheduleState === 'set-arming-source'">
  <div class="item-row">
    <div class="flex-column align-center justify-center" style="justify-content: center;width: 100%;">
      <div class="mb-14">
        <comp-icon [icon]="'safety_check'" [size]="'40'" [color]="'#8792A2'"></comp-icon>
      </div>
      <div class="mb-20">
        <div class="arming-description">Arming schedules are only supported on CHeKT Video Security System sites.</div>
      </div>
      <div>
        <div class="btn-area" *ngIf="canEdit()">
          <div class="button button-white" (click)="openArmEdit()" [class.disabled]="isLoading || !canControlSchedulArming()">
            <div class="btn-inner">Change site arming source</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="widget-body" *ngIf="armingScheduleState === 'no-timezone'">
  <div class="item-row">
    <div class="flex-column align-center justify-center" style="justify-content: center;width: 100%;">
      <div class="mb-14">
        <comp-icon [icon]="'safety_check'" [size]="'40'" [color]="'#8792A2'"></comp-icon>
      </div>
      <div class="mb-20">
        <div class="arming-description">Arming schedules can’t be used because the site time zone is not set.</div>
      </div>
      <div>
        <div class="btn-area">
          <div class="button button-white" (click)="goToGeneralTab()" [class.disabled]="isLoading || !canControlSchedulArming()">
            <div class="btn-inner">Set timezone</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div [ngClass]="armingScheduleState === 'schedule-table' ? 'show' : 'hide'">
  <div class="widget-body">
    <div class="item-row" style="height: 38px; box-sizing: border-box;">
      <div class="row" style="width: 200px; overflow: initial;">
        <div class="arming-label">Status</div>
      </div>
      <div class="row" *ngIf="isEditMode">
        <mat-slide-toggle #schedulenableToggle [(ngModel)]="editArmingScheduleEnabled">{{ editArmingScheduleEnabled ? 'Enabled' : 'Disabled' }}</mat-slide-toggle>
      </div>
      <div class="row" *ngIf="!isEditMode"><span class="tag" [class.enabled]="originalArmingScheduleEnabled === 1" [class.disabled]="originalArmingScheduleEnabled === 0">{{originalArmingScheduleEnabled === 1 ? 'Enabled' : 'Disabled'}}</span></div>
    </div>
  </div>
  <ng-container *ngFor="let week of weeks; let i = index">
    <div class="arming-day">
      <div class="day-of-week">{{ week }}</div>
      <div class="arming-container" #armingContainer>
        <!-- amContainer-->
        <div class="arming-box am" #amContainer (mousemove)="onMouseMove($event, i, 'am')" (mouseleave)="onMouseLeave('am', i)">
          <div class="preview" *ngIf="amHoveredTime[i+1]" [style.left.px]="getTimeXPosition(amHoveredTime[i+1], amContainerWidth, false)" (click)="addPreview(amHoveredTime[i+1], i+1)">{{ amHoveredTime[i+1] }}</div>
          <div class="more-content v-center" #actionMenus *ngFor="let schedule of armingSchedules[i+1].am" [style.left.px]="getTimeXPosition(schedule.startTime, amContainerWidth, false)" [id]="'schedule-'+schedule.id" (mouseenter)="setScheduleEditIcon(schedule)" (mouseleave)="closeScheduleEditIcon(schedule)">
            <div class="schedule-time" [ngClass]="computedScheduleStyleClass(schedule)" appDraggableSchedule="appDraggableSchedule" [armingSchedules]="armingSchedules" [schedule]="schedule" [container]="armingContainer" [isPm]="false" [week]="i" [getTimeFromPosition]="getTimeFromPosition" [isEditMode]="isEditMode" (update)="updateDrag($event)">{{schedule.startTime}}</div>
            <div class="more delete" [class.visible]="isEditMode" [id]="'more-schedule-'+schedule.id" (click)="deleteSchedule($event, i, schedule, 'am')"><i class="material-icons">close</i></div>
            <div class="more edit" [class.visible]="schedule.isShowMenu" [id]="'more-schedule-'+schedule.id" (click)="openAddArmSchedule(schedule)"><i class="material-icons">edit</i></div>
            <div class="more arm" *ngIf="schedule.type != 1" [class.visible]="isEditMode" [id]="'more-schedule-'+schedule.id" (click)="updateArmingStatus($event, 1, i, schedule, 'am')"></div>
            <div class="more disarm" *ngIf="schedule.type != 2" [class.visible]="isEditMode" [id]="'more-schedule-'+schedule.id" (click)="updateArmingStatus($event, 2, i, schedule, 'am')"></div>
          </div>
        </div>
        <!-- pmContainer-->
        <div class="arming-box pm" #pmContainer (mousemove)="onMouseMove($event, i, 'pm')" (mouseleave)="onMouseLeave('pm', i)">
          <div class="preview" *ngIf="pmHoveredTime[i+1]" [style.left.px]="getTimeXPosition(pmHoveredTime[i+1], pmContainerWidth, true)" (click)="addPreview(pmHoveredTime[i+1], i+1)">{{ pmHoveredTime[i+1] }}</div>
          <div class="more-content v-center" #actionMenus *ngFor="let schedule of armingSchedules[i+1].pm" [style.left.px]="getTimeXPosition(schedule.startTime, pmContainerWidth, true)" [id]="'schedule-'+schedule.id" (mouseenter)="setScheduleEditIcon(schedule)" (mouseleave)="closeScheduleEditIcon(schedule)">
            <div class="schedule-time" [ngClass]="computedScheduleStyleClass(schedule)" appDraggableSchedule="appDraggableSchedule" [armingSchedules]="armingSchedules" [schedule]="schedule" [container]="armingContainer" [isPm]="true" [week]="i" [getTimeFromPosition]="getTimeFromPosition" [isEditMode]="isEditMode" (update)="updateDrag($event)">{{schedule.startTime}}</div>
            <div class="more delete" [class.visible]="isEditMode" [id]="'more-schedule-'+schedule.id" (click)="deleteSchedule($event, i, schedule, 'pm')"><i class="material-icons">close</i></div>
            <div class="more edit" [class.visible]="schedule.isShowMenu" [id]="'more-schedule-'+schedule.id" (click)="openAddArmSchedule(schedule)"><i class="material-icons">edit</i></div>
            <div class="more arm" *ngIf="schedule.type != 1" [class.visible]="isEditMode" [id]="'more-schedule-'+schedule.id" (click)="updateArmingStatus($event, 1, i, schedule, 'pm')"></div>
            <div class="more disarm" *ngIf="schedule.type != 2" [class.visible]="isEditMode" [id]="'more-schedule-'+schedule.id" (click)="updateArmingStatus($event, 2, i, schedule, 'pm')"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<dealer-site-arm-schedule [modal]="m_arm_schedule" [active]="m_arm_schedule.is_active" [site]="site" (onClose)="closeAddArmSchedule($event)"></dealer-site-arm-schedule>
<app-site-arm-edit [modal]="m_siteArmEdit" [active]="m_siteArmEdit.is_active" [site]="site" (onClose)="closeArmEdit()"></app-site-arm-edit>
